import { useState } from 'react';
import { Icon } from './ui/Icon';
import type { FaqEntry } from '../types';

export interface FAQAccordionProps {
  entries: FaqEntry[];
  idPrefix?: string;
}

export function FAQAccordion({ entries, idPrefix = 'faq' }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-slate-200/80">
      {entries.map((entry, index) => {
        const isOpen = openIndex === index;
        const panelId = `${idPrefix}-panel-${index}`;
        const buttonId = `${idPrefix}-button-${index}`;

        return (
          <div key={entry.question}>
            <h3>
              <button
                type="button"
                id={buttonId}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-semibold tracking-[-0.015em] text-primary-500 transition-[color,transform] duration-100 ease-out hover:text-secondary-600 active:scale-[0.995] motion-reduce:active:scale-100 sm:py-6 sm:text-lg"
              >
                {entry.question}
                <Icon
                  name="chevron-down"
                  className={`h-5 w-5 shrink-0 text-secondary-500 transition-transform duration-300 ease-out motion-reduce:transition-none ${isOpen ? 'rotate-180' : ''}`}
                  strokeWidth={2}
                />
              </button>
            </h3>

            <div
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              hidden={!isOpen}
              className="pb-5 text-base leading-relaxed text-slate-600 sm:pb-6"
            >
              {entry.answer}
            </div>
          </div>
        );
      })}
    </div>
  );
}
